import { createContext } from 'react';

/**
 * Admin User Context
 * Provides authentication state and methods for admin features
 */
export const AdminUserContext = createContext({
  user: null,
  loading: true,
  error: null,
  logout: () => {},
  checkAuthStatus: () => {},
  isAuthenticated: false,
  hasAdminAccess: () => false
});